module.exports = __webpack_public_path__ + "img/ico-question-mark-alt.2afd538e.svg";